import React from 'react';
import styled from 'styled-components';
import PoweredBy from './PoweredBy';
import OnlineStatusIndicator from './OnlineStatusIndicator';

const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const MainContent = styled.main`
  margin-left: 260px; // Width of the desktop navigation
  padding: ${({ theme }) => theme.spacing[4]};
  flex: 1;
  background: ${({ theme }) => theme.colors.background};
  padding-top: ${({ theme }) => theme.spacing[4]}; // Add consistent top padding
  display: flex;
  flex-direction: column;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin-left: 0;
    padding-top: 60px; // Height of mobile header
    padding-bottom: 70px; // Height of mobile navigation
  }
`;

const ContentWrapper = styled.div`
  flex: 1;
`;

interface LayoutProps {
  children: React.ReactNode;
  showPoweredBy?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, showPoweredBy = true }) => {
  return (
    <LayoutWrapper>
      <MainContent>
        <ContentWrapper>{children}</ContentWrapper>
        {showPoweredBy && <PoweredBy />}
        
      </MainContent>
      <OnlineStatusIndicator />
    </LayoutWrapper>
  );
};

export default Layout;